export const translations = {
  en: {
    nav: {
      home: "Home",
      about: "About",
      listings: "Listings",
      neighborhoods: "Neighborhoods",
      valuation: "Home Valuation",
      testimonials: "Testimonials",
      developments: "Developments",
      contact: "Contact",
      connect: "Let's Connect",
      menu: "Menu",
      close: "Close",
    },
    hero: {
      badge: "Miami · South Florida Residential Specialist",
      line1: "Every home",
      line2: "tells a story —",
      line3: "let's find yours.",
      subtitle: "Hands-on guidance for first-time buyers and seasoned movers across South Florida, from Brickell to Coral Gables.",
      cta1: "Browse Homes",
      cta2: "Get a Home Valuation",
      searchPlaceholder: "Enter city, neighborhood, zip, or address",
      scroll: "Scroll",
    },
    stats: {
      areasLabel: "Areas We Serve",
      items: [
        { value: "$10M+", label: "Sales Volume" },
        { value: "100%", label: "Hands-On Service" },
        { value: "EN · ES", label: "Bilingual Guidance" },
      ],
    },
    intro: {
      overline: "Your Agent",
      title: "Driven. Detail-oriented. Dedicated to your move.",
      bio1: "I am part of a new generation of South Florida real estate — newer to the industry, but already closing a volume of deals that rivals seasoned veterans. My edge is simple: relentless energy, fast answers, and genuine care for every client.",
      bio2: "Whether you're buying your first home or moving up to your forever one, I walk you through every step personally — no handoffs, no voicemail, no guessing.",
      link: "More about me",
      badge: "Carlos Vindel",
      badgeSub: "Licensed Real Estate Sales Associate",
    },
    listingsSection: {
      overline: "Portfolio",
      title: "Featured Listings",
      subtitle: "A selection of homes currently on the market across South Florida.",
      viewAll: "View all listings",
      beds: "Beds",
      baths: "Baths",
      sqft: "Sq Ft",
      viewZillow: "View on Zillow",
    },
    valuationTeaser: {
      overline: "Home Valuation",
      title: "Know what your home is worth",
      subtitle: "Get a data-backed valuation prepared personally by me — not an algorithm's guess.",
      name: "Full name",
      email: "Email",
      phone: "Phone",
      address: "Property address",
      cta: "Get My Valuation",
    },
    neighborhoodsSection: {
      overline: "Explore",
      title: "South Florida, neighborhood by neighborhood",
      subtitle: "Each corner of Miami has its own rhythm. Find the one that matches yours.",
      readMore: "Read more",
      median: "Median price",
    },
    testimonialsSection: {
      overline: "Client Stories",
      title: "What clients say",
      verified: "Verified client",
    },
    developments: {
      overline: "Pre-Construction",
      title: "The Next Miami",
      subtitle: "A curated look at South Florida's most anticipated pre-construction projects — with early-buyer incentives you won't find on resale.",
      from: "From",
      cta: "Request details",
      viewAll: "View all projects",
    },
    ctaBand: {
      title: "Ready to find your next home?",
      subtitle: "One conversation is all it takes to get started. No pressure, no obligation — just honest guidance.",
      cta: "Start the Conversation",
      call: "Or call directly",
    },
    marquee: ["Coral Gables", "Brickell", "Coconut Grove", "Miami Beach", "Doral", "Kendall", "South Florida"],
    about: {
      overline: "About Me",
      title: "The next generation of South Florida real estate",
      lead: "I didn't inherit a book of business — I built one, deal by deal, by outworking and out-caring the competition.",
      bio1: "Newer to the industry but already highly active, I've helped numerous clients across Miami close with confidence. My approach blends modern market analytics with old-fashioned availability: when you call, I answer. When you need a showing, I make it happen.",
      bio2: "As a bilingual agent with deep roots in the Miami area, I guide first-time buyers through every acronym and inspection, and help sellers position their homes to stand out in a competitive market.",
      personalTitle: "A personal connection",
      personal: "Miami isn't just my market — it's home. From weekend walks through Coconut Grove to the energy of Brickell, I sell the lifestyle because I live it.",
      chaptersOverline: "Why work with me",
      chaptersTitle: "What you can count on",
      chapters: [
        { num: "01", title: "Hands-On Guidance", desc: "I manage every transaction personally — from the first tour to the final signature. No assistants, no handoffs." },
        { num: "02", title: "First-Time Buyer Friendly", desc: "Down-payment programs, inspections, escrow, homestead — explained in plain English (o en español), step by step." },
        { num: "03", title: "Always Available", desc: "Evenings, weekends, last-minute showings. Real estate moves fast in Miami, and I move with it." },
        { num: "04", title: "Local Market Knowledge", desc: "Street-by-street pricing insight from Brickell to Kendall, including off-market opportunities you won't find online." },
      ],
      cta: "Let's work together",
    },
    listingsPage: {
      overline: "Portfolio",
      title: "Listings",
      subtitle: "Current opportunities and recent successes across South Florida.",
      all: "All",
      forSale: "For Sale",
      sold: "Sold",
      forLease: "For Lease",
      perMonth: "/mo",
      empty: "No listings in this category right now.",
    },
    neighborhoodsPage: {
      overline: "Local Expertise",
      title: "Neighborhoods",
      subtitle: "Where you live shapes how you live. Explore South Florida's most sought-after communities.",
      readMore: "Read more",
      median: "Median price",
      highlights: "Highlights",
      listingsHere: "Listings in",
      back: "All neighborhoods",
      ctaTitle: "Thinking about this area?",
      ctaSub: "I know these streets personally. Ask me anything.",
      cta: "Message me",
    },
    developmentsPage: {
      overline: "Pre-Construction",
      title: "The Next Miami",
      subtitle: "A curated catalog of South Florida's most anticipated pre-construction projects. Buying early means better prices, better units, and developer incentives — I guide you through all of it.",
      allAreas: "All areas",
      searchPlaceholder: "Search by name, area or address",
      note: "Inventory, pricing and incentives change weekly in pre-construction. Ask me for the current availability sheet of any project.",
    },
    valuationPage: {
      overline: "Home Valuation",
      title: "What is your South Florida home worth?",
      subtitle: "Receive a personalized, data-backed Comparative Market Analysis prepared by me within 24 hours — free and with no obligation.",
      trust1: "Real local comparable sales, not automated guesses",
      trust2: "Prepared personally by me within 24 hours",
      trust3: "Completely free, no obligation to list",
      steps: ["Your address", "Property details", "Your timeline", "How to reach you"],
      propertyDetails: "Property details",
      address: "Street address",
      city: "City",
      zip: "ZIP code",
      type: "Property type",
      typeOptions: ["Single-family home", "Condo", "Townhouse", "Multi-family", "Other"],
      beds: "Bedrooms",
      baths: "Bathrooms",
      sqft: "Approx. square feet",
      condition: "Condition",
      conditionOptions: ["Recently renovated", "Well maintained", "Needs some work", "Needs major updates"],
      timeline: "Selling timeline",
      timelineOptions: ["As soon as possible", "1–3 months", "3–6 months", "Just curious"],
      contactInfo: "Contact information",
      name: "Full name",
      email: "Email",
      phone: "Phone",
      notes: "Anything else we should know? (upgrades, view, lot…)",
      cta: "Request My Valuation",
    },
    testimonialsPage: {
      overline: "Client Stories",
      title: "Testimonials",
      subtitle: "Real words from buyers and sellers across South Florida.",
    },
    contactPage: {
      overline: "Contact",
      title: "Let's talk about your move",
      subtitle: "Buying, selling, or just exploring — the first conversation is always free.",
      name: "Full name",
      email: "Email",
      phone: "Phone",
      interest: "I'm interested in",
      interestOptions: ["Buying", "Selling", "Renting", "Something else"],
      budget: "Budget / target price (optional)",
      message: "Message",
      prefillDevelopment: "Hi Carlos, I'd like more details about {name} — availability, pricing and buyer incentives.",
      cta: "Send Message",
      directTitle: "Talk to me directly",
      phoneLabel: "Phone",
      emailLabel: "Email",
      locationLabel: "Location",
      location: "Miami, FL",
      brokerageLabel: "Brokerage",
      hoursLabel: "Hours",
      hours: "Mon – Sun · 8 AM – 8 PM",
      followLabel: "Follow",
    },
    form: {
      success: "Thank you! I'll reach out shortly.",
      successValuation: "Request received! Your valuation is on its way within 24 hours.",
      error: "Something went wrong. Please try again or call directly.",
      sending: "Sending…",
      required: "Please complete the required fields.",
    },
    admin: {
      loginTitle: "Admin Login",
      loginSubtitle: "Sign in to manage leads and listings.",
      email: "Email",
      password: "Password",
      signIn: "Sign in",
      dashboard: "Admin Dashboard",
      leadsTab: "Leads",
      listingsTab: "Listings",
      logout: "Log out",
      noLeads: "No leads yet.",
      contactType: "Contact",
      valuationType: "Valuation",
      leadStatus: "Status",
      leadStatusOptions: ["New", "Contacted", "In progress", "Closed"],
      statusUpdated: "Lead status updated.",
      addListing: "Add listing",
      editListing: "Edit listing",
      deleteConfirm: "Delete this listing?",
      save: "Save",
      cancel: "Cancel",
      saved: "Listing saved.",
      deleted: "Listing deleted.",
      address: "Address",
      neighborhood: "Neighborhood",
      status: "Status",
      price: "Price (USD)",
      beds: "Beds",
      baths: "Baths",
      sqft: "Sq Ft",
      imageUrl: "Image URL",
      zillowUrl: "Zillow listing URL",
      uploadPhoto: "Upload photo",
      uploading: "Uploading…",
      orPasteUrl: "or paste an image URL",
      photoUploaded: "Photo uploaded.",
      featured: "Featured on homepage",
      backToSite: "Back to site",
      loginFailed: "Invalid email or password.",
      testimonialsTab: "Testimonials",
      settingsTab: "Site Settings",
      addTestimonial: "Add testimonial",
      editTestimonial: "Edit testimonial",
      deleteTestimonialConfirm: "Delete this testimonial?",
      clientName: "Client name",
      contextEn: "Context (EN)",
      contextEs: "Context (ES)",
      quoteEn: "Quote (EN)",
      quoteEs: "Quote (ES)",
      contentSaved: "Settings saved.",
      phoneLabel: "Phone shown on site",
      emailLabel: "Email shown on site",
      hoursEn: "Hours (EN)",
      hoursEs: "Hours (ES)",
      statsTitle: "Homepage stats",
      valueLabel: "Value",
      labelEn: "Label (EN)",
      labelEs: "Label (ES)",
      marqueeTitle: "Locations strip",
      marqueeEn: "English, comma separated",
      marqueeEs: "Spanish, comma separated",
      contactInfoTitle: "Contact info shown on the site",
      saveSettings: "Save settings",
      developmentsTab: "Developments",
      addDevelopment: "Add development",
      editDevelopment: "Edit development",
      deleteDevelopmentConfirm: "Delete this development?",
      devName: "Development name",
      areaLabel: "Area",
      priceFrom: "Price from (USD)",
      priceTo: "Price up to (USD)",
    },
    footer: {
      tagline: "Every home tells a story — let's find yours.",
      navigate: "Navigate",
      contactTitle: "Contact",
      license: "FL Real Estate License #3654913",
      rights: "All rights reserved.",
      brokerage: "Brokered by",
    },
  },
  es: {
    nav: {
      home: "Inicio",
      about: "Sobre mí",
      listings: "Propiedades",
      neighborhoods: "Vecindarios",
      valuation: "Valuación",
      testimonials: "Testimonios",
      developments: "Desarrollos",
      contact: "Contacto",
      connect: "Hablemos",
      menu: "Menú",
      close: "Cerrar",
    },
    hero: {
      badge: "Especialista Residencial en Miami y el Sur de la Florida",
      line1: "Cada hogar",
      line2: "cuenta una historia —",
      line3: "encontremos la tuya.",
      subtitle: "Acompañamiento personalizado para compradores primerizos y clientes residenciales en todo el Sur de la Florida, de Brickell a Coral Gables.",
      cta1: "Ver Propiedades",
      cta2: "Valora tu Propiedad",
      searchPlaceholder: "Busca por ciudad, vecindario, código postal o dirección",
      scroll: "Desliza",
    },
    stats: {
      areasLabel: "Zonas Que Servimos",
      items: [
        { value: "$10M+", label: "Volumen de Ventas" },
        { value: "100%", label: "Servicio Personalizado" },
        { value: "EN · ES", label: "Atención Bilingüe" },
      ],
    },
    intro: {
      overline: "Tu Agente",
      title: "Dedicado. Detallista. Comprometido con tu mudanza.",
      bio1: "Soy parte de una nueva generación en el sector inmobiliario del Sur de la Florida: nuevo en la industria, pero ya cerrando un volumen de negocios que rivaliza con agentes veteranos. Mi ventaja es simple: energía incansable, respuestas rápidas y un interés genuino por cada cliente.",
      bio2: "Ya sea que compres tu primera casa o te mudes a la casa de tus sueños, te acompaño personalmente en cada paso — sin intermediarios, sin esperas, sin dudas.",
      link: "Conoce más sobre mí",
      badge: "Carlos Vindel",
      badgeSub: "Agente de Bienes Raíces Licenciado",
    },
    listingsSection: {
      overline: "Portafolio",
      title: "Propiedades Destacadas",
      subtitle: "Una selección de casas actualmente en el mercado del Sur de la Florida.",
      viewAll: "Ver todas las propiedades",
      beds: "Hab.",
      baths: "Baños",
      sqft: "Pies²",
      viewZillow: "Ver en Zillow",
    },
    valuationTeaser: {
      overline: "Valuación de Propiedad",
      title: "Conoce cuánto vale tu casa",
      subtitle: "Recibe una valuación basada en datos, preparada personalmente por mí — no la estimación de un algoritmo.",
      name: "Nombre completo",
      email: "Correo electrónico",
      phone: "Teléfono",
      address: "Dirección de la propiedad",
      cta: "Obtener Mi Valuación",
    },
    neighborhoodsSection: {
      overline: "Explora",
      title: "El Sur de la Florida, vecindario por vecindario",
      subtitle: "Cada rincón de Miami tiene su propio ritmo. Encuentra el que combine con el tuyo.",
      readMore: "Leer más",
      median: "Precio medio",
    },
    testimonialsSection: {
      overline: "Historias de Clientes",
      title: "Lo que dicen los clientes",
      verified: "Cliente verificado",
    },
    developments: {
      overline: "Pre-Construcción",
      title: "El Nuevo Miami",
      subtitle: "Una selección de los proyectos de pre-construcción más esperados del Sur de la Florida — con incentivos para compradores tempranos que no encontrarás en reventa.",
      from: "Desde",
      cta: "Pedir detalles",
      viewAll: "Ver todos los proyectos",
    },
    ctaBand: {
      title: "¿Listo para encontrar tu próximo hogar?",
      subtitle: "Una conversación es todo lo que necesitas para empezar. Sin presión, sin compromiso — solo orientación honesta.",
      cta: "Iniciar la Conversación",
      call: "O llama directamente",
    },
    marquee: ["Coral Gables", "Brickell", "Coconut Grove", "Miami Beach", "Doral", "Kendall", "Sur de la Florida"],
    about: {
      overline: "Sobre Mí",
      title: "La nueva generación de bienes raíces en el Sur de la Florida",
      lead: "No heredé una cartera de clientes — la construí, negocio a negocio, trabajando más y cuidando mejor que la competencia.",
      bio1: "Nuevo en la industria pero ya muy activo, he ayudado a numerosos clientes en Miami a cerrar con confianza. Mi enfoque combina análisis moderno del mercado con disponibilidad a la antigua: cuando llamas, respondo. Cuando necesitas ver una propiedad, lo hago posible.",
      bio2: "Como agente bilingüe con profundas raíces en Miami, guío a compradores primerizos a través de cada sigla e inspección, y ayudo a vendedores a posicionar sus casas para destacar en un mercado competitivo.",
      personalTitle: "Una conexión personal",
      personal: "Miami no es solo mi mercado — es mi hogar. Desde caminatas de fin de semana por Coconut Grove hasta la energía de Brickell, vendo el estilo de vida porque lo vivo.",
      chaptersOverline: "Por qué trabajar conmigo",
      chaptersTitle: "Con qué puedes contar",
      chapters: [
        { num: "01", title: "Acompañamiento Total", desc: "Manejo cada transacción personalmente — desde el primer recorrido hasta la firma final. Sin asistentes, sin intermediarios." },
        { num: "02", title: "Amigable con Compradores Primerizos", desc: "Programas de ayuda para el enganche, inspecciones, escrow, homestead — explicado en español claro, paso a paso." },
        { num: "03", title: "Siempre Disponible", desc: "Noches, fines de semana, visitas de último minuto. Los bienes raíces se mueven rápido en Miami, y yo me muevo con ellos." },
        { num: "04", title: "Conocimiento del Mercado Local", desc: "Perspectiva de precios calle por calle, de Brickell a Kendall, incluyendo oportunidades fuera del mercado que no encontrarás en línea." },
      ],
      cta: "Trabajemos juntos",
    },
    listingsPage: {
      overline: "Portafolio",
      title: "Propiedades",
      subtitle: "Oportunidades actuales y éxitos recientes en el Sur de la Florida.",
      all: "Todas",
      forSale: "En Venta",
      sold: "Vendidas",
      forLease: "En Alquiler",
      perMonth: "/mes",
      empty: "No hay propiedades en esta categoría por ahora.",
    },
    neighborhoodsPage: {
      overline: "Experiencia Local",
      title: "Vecindarios",
      subtitle: "Dónde vives define cómo vives. Explora las comunidades más codiciadas del Sur de la Florida.",
      readMore: "Leer más",
      median: "Precio medio",
      highlights: "Puntos destacados",
      listingsHere: "Propiedades en",
      back: "Todos los vecindarios",
      ctaTitle: "¿Pensando en esta zona?",
      ctaSub: "Conozco estas calles personalmente. Pregúntame lo que quieras.",
      cta: "Escríbeme",
    },
    developmentsPage: {
      overline: "Pre-Construcción",
      title: "El Nuevo Miami",
      subtitle: "Un catálogo curado de los proyectos de pre-construcción más esperados del Sur de la Florida. Comprar temprano significa mejores precios, mejores unidades e incentivos del desarrollador — yo te guío en todo.",
      allAreas: "Todas las zonas",
      searchPlaceholder: "Busca por nombre, zona o dirección",
      note: "El inventario, los precios y los incentivos cambian semanalmente en pre-construcción. Pídeme la lista de disponibilidad actualizada de cualquier proyecto.",
    },
    valuationPage: {
      overline: "Valuación de Propiedad",
      title: "¿Cuánto vale tu casa en el Sur de la Florida?",
      subtitle: "Recibe un Análisis Comparativo de Mercado personalizado y basado en datos, preparado por mí en 24 horas — gratis y sin compromiso.",
      trust1: "Ventas comparables locales reales, no estimaciones automáticas",
      trust2: "Preparado personalmente por mí en 24 horas",
      trust3: "Completamente gratis, sin obligación de listar",
      steps: ["Tu dirección", "Detalles de la propiedad", "Tu cronograma", "Cómo contactarte"],
      propertyDetails: "Detalles de la propiedad",
      address: "Dirección",
      city: "Ciudad",
      zip: "Código postal",
      type: "Tipo de propiedad",
      typeOptions: ["Casa unifamiliar", "Condominio", "Casa adosada", "Multifamiliar", "Otro"],
      beds: "Habitaciones",
      baths: "Baños",
      sqft: "Pies cuadrados aprox.",
      condition: "Condición",
      conditionOptions: ["Recién renovada", "Bien mantenida", "Necesita algunos arreglos", "Necesita remodelación mayor"],
      timeline: "Cronograma de venta",
      timelineOptions: ["Lo antes posible", "1–3 meses", "3–6 meses", "Solo tengo curiosidad"],
      contactInfo: "Información de contacto",
      name: "Nombre completo",
      email: "Correo electrónico",
      phone: "Teléfono",
      notes: "¿Algo más que debamos saber? (mejoras, vista, terreno…)",
      cta: "Solicitar Mi Valuación",
    },
    testimonialsPage: {
      overline: "Historias de Clientes",
      title: "Testimonios",
      subtitle: "Palabras reales de compradores y vendedores en el Sur de la Florida.",
    },
    contactPage: {
      overline: "Contacto",
      title: "Hablemos de tu mudanza",
      subtitle: "Comprar, vender o solo explorar — la primera conversación siempre es gratis.",
      name: "Nombre completo",
      email: "Correo electrónico",
      phone: "Teléfono",
      interest: "Me interesa",
      interestOptions: ["Comprar", "Vender", "Alquilar", "Otra cosa"],
      budget: "Presupuesto / precio objetivo (opcional)",
      message: "Mensaje",
      prefillDevelopment: "Hola Carlos, me gustaría más detalles sobre {name} — disponibilidad, precios e incentivos para compradores.",
      cta: "Enviar Mensaje",
      directTitle: "Habla conmigo directamente",
      phoneLabel: "Teléfono",
      emailLabel: "Correo",
      locationLabel: "Ubicación",
      location: "Miami, FL",
      brokerageLabel: "Correduría",
      hoursLabel: "Horario",
      hours: "Lun – Dom · 8 AM – 8 PM",
      followLabel: "Sígueme",
    },
    form: {
      success: "¡Gracias! Me pondré en contacto pronto.",
      successValuation: "¡Solicitud recibida! Tu valuación estará lista en 24 horas.",
      error: "Algo salió mal. Inténtalo de nuevo o llama directamente.",
      sending: "Enviando…",
      required: "Por favor completa los campos requeridos.",
    },
    admin: {
      loginTitle: "Acceso de Administrador",
      loginSubtitle: "Inicia sesión para gestionar leads y propiedades.",
      email: "Correo electrónico",
      password: "Contraseña",
      signIn: "Iniciar sesión",
      dashboard: "Panel de Administración",
      leadsTab: "Leads",
      listingsTab: "Propiedades",
      logout: "Cerrar sesión",
      noLeads: "Aún no hay leads.",
      contactType: "Contacto",
      valuationType: "Valuación",
      leadStatus: "Estado",
      leadStatusOptions: ["Nuevo", "Contactado", "En proceso", "Cerrado"],
      statusUpdated: "Estado del lead actualizado.",
      addListing: "Agregar propiedad",
      editListing: "Editar propiedad",
      deleteConfirm: "¿Eliminar esta propiedad?",
      save: "Guardar",
      cancel: "Cancelar",
      saved: "Propiedad guardada.",
      deleted: "Propiedad eliminada.",
      address: "Dirección",
      neighborhood: "Vecindario",
      status: "Estado",
      price: "Precio (USD)",
      beds: "Hab.",
      baths: "Baños",
      sqft: "Pies²",
      imageUrl: "URL de imagen",
      zillowUrl: "Enlace de Zillow",
      uploadPhoto: "Subir foto",
      uploading: "Subiendo…",
      orPasteUrl: "o pega la URL de una imagen",
      photoUploaded: "Foto subida.",
      featured: "Destacada en la portada",
      backToSite: "Volver al sitio",
      loginFailed: "Correo o contraseña inválidos.",
      testimonialsTab: "Testimonios",
      settingsTab: "Configuración",
      addTestimonial: "Agregar testimonio",
      editTestimonial: "Editar testimonio",
      deleteTestimonialConfirm: "¿Eliminar este testimonio?",
      clientName: "Nombre del cliente",
      contextEn: "Contexto (EN)",
      contextEs: "Contexto (ES)",
      quoteEn: "Cita (EN)",
      quoteEs: "Cita (ES)",
      contentSaved: "Configuración guardada.",
      phoneLabel: "Teléfono del sitio",
      emailLabel: "Correo del sitio",
      hoursEn: "Horario (EN)",
      hoursEs: "Horario (ES)",
      statsTitle: "Estadísticas de la portada",
      valueLabel: "Valor",
      labelEn: "Etiqueta (EN)",
      labelEs: "Etiqueta (ES)",
      marqueeTitle: "Tira de ubicaciones",
      marqueeEn: "Inglés, separadas por comas",
      marqueeEs: "Español, separadas por comas",
      contactInfoTitle: "Información de contacto del sitio",
      saveSettings: "Guardar configuración",
      developmentsTab: "Desarrollos",
      addDevelopment: "Agregar desarrollo",
      editDevelopment: "Editar desarrollo",
      deleteDevelopmentConfirm: "¿Eliminar este desarrollo?",
      devName: "Nombre del desarrollo",
      areaLabel: "Zona",
      priceFrom: "Precio desde (USD)",
      priceTo: "Precio hasta (USD)",
    },
    footer: {
      tagline: "Cada hogar cuenta una historia — encontremos la tuya.",
      navigate: "Navegación",
      contactTitle: "Contacto",
      license: "Licencia de Bienes Raíces FL #3654913",
      rights: "Todos los derechos reservados.",
      brokerage: "Afiliado a",
    },
  },
};
